<template>
  <div class="m-message">
    <van-list v-model="loading" :finished="finished" :immediate-check="immediateCheck" :offset="offset"
      :direction="direction" @load="onLoad">
      <ul>
        <li v-for="(item, index) in messageListA" :key="index">
          <!-- <p class="time"><span>{{item.createdTime.replace(/-/g, '/') | time}}</span></p> -->
          <p class="time"><span>{{timeFormat(item.createdTime, 'yyyy/MM/dd hh:mm:ss')}}</span></p>
          <p class="time" v-if="item.contentType === -1 ||
                item.contentType === 19 ||
                item.contentType === 2000 ||
                item.contentType === 2001 "><span>{{item.content || "此类型消息请在手机上查收"}} </span></p>
          <!-- <p class="time" v-if="item.contentType === 3"><span>收到语音消息，请手机接听 </span></p> -->
          <!--0文本；1图片；2视频；3语音；4文件；5链接；-1未知； 33 表示小程序-->
          <div class="m-message-div clearfloat" :class="item.self ? 'self':''">
            <div v-if="item.contentType !== -1 &&
                    item.contentType !== 19 &&
                    item.contentType !== 2000 &&
                    item.contentType !== 2001 " class="clearfloat">
              <img class="avatar" width="30" height="30" :src="item.sendUrl || logo" />
            </div>
            <span>
              <!-- isSend === 1 表示主动发送消息，sendSuccess表示是否发送成功 消息发不出去时的样式   -->
              <van-icon name="close" color="red" v-if="item.isSend === 1 && !item.sendSuccess" />
            </span>
            <!-- 文本 -->
            <div class="text" v-if="item.contentType === 0" v-html="item.content"></div>
            <!--图片-->
            <div class="text-img" v-if="item.contentType === 1" @click="openUrl(item.content)"><img :src="item.content"
                alt="" /></div>
            <!-- 文件样式 -->
            <div v-if="item.contentType === 4" class="text-file-img clearfloat" @click="openUrl(item.cUrl)">
              <div class="text-file-img-left">
                <div class="text-file-name">{{item.cTitle}}</div>
                <div class="text-file-size">{{item.cText}}</div>
              </div>
              <div class="text-file-img-right">
                <img :src="item.cImg" />
              </div>
            </div>
            <!-- 链接样式 -->
            <div v-if="item.contentType === 5" class="text-url-img" @click="openUrl(item.cUrl)">
              <div class="text-url-img-top">{{item.cTitle}}</div>
              <div class="text-url-img-bottom clearfloat">
                <div class="text-url-img-content">{{item.cText}}</div>
                <img :src="item.cImg || require('_a/images/wxlinkURL.png')" />
              </div>
            </div>
            <!-- 音频样式 -->
            <div v-if="item.contentType === 3" class="audio">
              <audio :src="item.content" width='80' height='40' controls></audio>
            </div>
            <!-- 视频样式 -->
            <div v-if="item.contentType === 2" class="text-video">
              <video class="video" :ref="'video-' + item.id" width="128" :src="item.content"
                @click="openUrl(item.content)">
              </video>
              <!-- <Icon type="ios-play" :ref="'video-play' + item.id" @click="handlePlay(item.id)" v-show="playVideo" />
              <Icon type="ios-pause" :ref="'video-pause' + item.id" v-show="!playVideo" @click="handlePause(item.id)" />-->
            </div>
            <!--视频号样式51-->
            <div class="text-video-code" v-if="item.contentType === 51" v-on:mouseenter="showDialog(index)"
              v-on:mouseleave="hideDialog(index)" :accesskey="index">
              <img class="text-video-code-top" :src="item.bigImg || vedioPic" alt="" />
              <div class="text-video-code-bottom">
                <img class="text-video-code-bottom-head" :src="item.miniImg" width="50" height="50" />
                <span class="text-video-code-bottom-title">{{item.miniTitle}}</span>
              </div>
              <div class="text-video-code-bottom-content">
                {{item.miniDsc && item.miniDsc.length >= 10 ? (item.miniDsc.substring(0, 10) + '···') : item.miniDsc}}
              </div>
              <div class="text-video-code-bom">
                <img width="20" height="20" style="vertical-align: middle;" :src="wxVideoCodePic" />
                <span style="margin-left: 4px; font-size: 12px;">视频号{{item.visible}}</span>
              </div>
            </div>
            <!--小程序样式33-->
            <div class="text-mini" v-if="item.contentType === 33" v-on:mouseenter="showDialog(index)"
              v-on:mouseleave="hideDialog(index)" :accesskey="index">
              <div class="text-mini-top">
                <img class="text-mini-top-img" :src="item.miniImg  || logo" alt="" />
                <span class="text-mini-top-span">{{item.miniName}}</span>
              </div>
              <div class="text-mini-title">
                <span class="text-mini-title-span">{{item.miniTitle}}</span>
              </div>
              <img class="text-mini-img" :src="miniPic" />
              <div class="text-mini-bom">
                <img style="vertical-align: middle; margin-left: 10px;" :src="miniPic2" />
                <span style="margin-left: 4px; font-size: 12px;">小程序</span>
              </div>
              <div class="handleDialog" v-if="ishow && index==current">
                <Button @click="handleCollect(item)" style="margin: 50% auto">收藏</Button>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </van-list>
  </div>
</template>

<script>
import excel from '_a/images/excel.png'
import world from '_a/images/world.png'
import ppt from '_a/images/ppt.png'
import pdf from '_a/images/pdf.png'
import txtIcon from '_a/images/txtIcon.png'
import zipIcon from '_a/images/zipIcon.png'
import unknowFileIcon from '_a/images/unknowFileIcon.png'
import wxVideoCodePic from '_a/images/wxVideoCodePic.png'
import miniPic from '_a/images/miniPic.png'
import miniPic2 from '_a/images/miniPic2.png'
import vedioPic from '_a/images/vedioPic.png'
import { emojiAxisConfig } from '@/utils/emojiAxisConfig.js'
import wxEmojSprite from '_a/images/wxEmojiSprite.png'
import bus from '@/utils/vueBus.js'
import { timeFormat } from '@/utils/index.js'

export default {
  data () {
    return {
      timeFormat,
      ishow: false,
      current: 0, //当前操作按钮
      vedioPic: vedioPic,
      miniPic: miniPic,
      miniPic2: miniPic2,
      wxVideoCodePic: wxVideoCodePic,
      wxEmojSprite: wxEmojSprite,
      logo: unknowFileIcon,
      // name: '',
      messageListA: [],
      playVideo: true, // 视频播放按钮
      currentPage: 1, // 历史记录当前页码
      pageSize: 7, // 历史记录每页条数 开发时填7，生产上可以改为20
      loading: false, // van组件上拉加载
      finished: false, // van组件上拉加载完毕
      offset: 10, // van组件滚动条与底部距离小于 offset 时触发load事件
      direction: 'up',
      loadHisMsg: false,
      immediateCheck: false,
      //accountId: 103184992210007, // 开发时使用，但实际上应该使用curSession的accountId
      //sessionId: 103193838510007,// 开发时使用，但实际上是使用curSession的id
    }
  },
  props: ['accountId', 'sessionId'],
  methods: {
    // 获取资源表单列表
    handleFindHistoryMsgBySessionId () {
      let params = {
        page: this.currentPage,
        pageCount: this.pageSize,
        accountId: this.accountId,
        sessionId: this.sessionId
      }
      this.$http.get(`/scrm/v1/qw-message/m/getMsgHisBySession`, {
        params: params
      }).then((res) => {
        let { data, code, msg } = res
        this.loading = false
        if (code === 1 && data !== null) {
          for (let i of data.records) {
            let flag = false
            for (let j of this.messageListA) {
              if (i.id === j.id) {
                flag = true
                break
              }
            }
            // 添加不重复的元素
            if (!flag) {
              this.messageListA.unshift(i)
              flag = false
            }
          }
          if (data.current === data.pages || data.pages === 0) {
            // 加载结束
            this.finished = true
          }
        }
      }).finally(() => {
        this.loading = false
        this.loadHisMsg = true
      })
    },
    // 下拉加载请求方法
    onLoad () {
      console.log('执行onload')
      this.currentPage++
      this.handleFindHistoryMsgBySessionId()
    },
    //显示操作项
    showDialog (index, item) {
      this.ishow = true
      this.current = index
    },
    //隐藏蒙层
    hideDialog (index, item) {
      this.ishow = false
      this.current = null
    },
    openUrl (cUrl) {
      window.open(cUrl, '_blank')
    },
    handlePlay (id) {
      this.$refs['video-' + id][0].play()
      this.$refs['video-play' + id][0].$el.style.display = 'none'
      this.$refs['video-pause' + id][0].$el.style.display = 'inline-block'
    },
    handlePause (id) {
      this.$refs['video-' + id][0].pause()
      this.$refs['video-play' + id][0].$el.style.display = 'inline-block'
      this.$refs['video-pause' + id][0].$el.style.display = 'none'
    },
    // 收藏
    handleCollect (item) {
      let _content = JSON.parse(item.content)
      let params = {
        ghId: _content.ghId,
        title: _content.miniTitle,
        name: _content.miniName,
        wxId: _content.wxId,
        enterPoint: _content.enterPoint,
        headImg: _content.miniImg,
        imageKey1: _content.imageKey1,
        imageKey2: _content.imageKey2,
        imageKey3: _content.imageKey3,
        imageSize: _content.imageSize,
      }
      this.$http.post(`/scrm/v1/qw-mini-program/m/add`, params).then(res => {
        if (res.code === 1) {
          //this.$Message.info('收藏成功')
          bus.$emit('wxbRefreshMaterial')
        } else {
          //this.$Message.warning(res.msg)
        }
      })
    },
  },
  mounted () {
    this.handleFindHistoryMsgBySessionId()
    console.log('执行message组件的mounted')
    bus.$off('pushMsgList')
    bus.$on('pushMsgList', (value) => {
      this.loadHisMsg = false
      let data = JSON.parse(JSON.stringify(value))
      if (Number(this.sessionId) === data.sessionId) {
        let existMsgList = this.messageListA.filter(item => {
          return value.id === item.id
        })
        if (existMsgList.length === 0) {
          this.messageListA.push(data)
        }
      }
    })
  },
  watch: {
    messageListA (newVal) {
      this.messageListA.map((item) => {
        if (item.contentType === 5) {
          // 用try catch 包起来是为了使得item.content解析失败的时候，还能继续执行下一次for循环
          try {
            let _content = JSON.parse(item.content)
            // 这里有个小bug,当链接的图片路径为空的时候需要与后端保持一致，现在暂未处理图片路径为空的情况
            item.cTitle = _content.ctitle
            item.cText = _content.ctext
            item.cImg = _content.cimg
            item.cUrl = _content.curl
          } catch (error) {
          }
        }
        //处理微信表情
        if (item.contentType === 0) {
          // 处理换行显示
          item.content = item.content.replace(/[\r\n]/g, '<br/>')
          // 处理表情
          for (let emojiObj of emojiAxisConfig) {
            let reg = new RegExp(`\\${emojiObj.emoji}`, 'g')
            if (reg.exec(item.content)) {
              // 雪碧图技术获取背景图片的某一块图片
              let imgHtml = '<span style="display:inline-block; background-image:url(' + this.wxEmojSprite + ');' +
                ' background-position:' + (-1 * emojiObj.startX) + 'px ' + (-1 * emojiObj.startY) + 'px;' +
                ' vertical-align: middle; height: 32px; width: 28px;"></span>'
              item.content = item.content.replace(reg, imgHtml)
            }
          }
        }
        // 文件类型
        if (item.contentType === 4) {
          try {
            let _content = JSON.parse(item.content)
            item.cTitle = _content.ctitle
            item.cText = _content.ctext
            item.cUrl = _content.curl
            let suffix = item.cTitle.substring(item.cTitle.lastIndexOf('.') + 1).toLowerCase()
            if (suffix === 'xls' || suffix === 'xlsx') {
              item.cImg = excel
            } else if (suffix === 'doc' || suffix === 'docx') {
              item.cImg = world
            } else if (suffix === 'ppt' || suffix === 'pptx') {
              item.cImg = ppt
            } else if (suffix === 'rar' || suffix === 'gzip' || suffix === 'zip' || suffix === 'arj' ||
              suffix === 'tar' || suffix === '7z') {
              item.cImg = zipIcon
            } else if (suffix === 'txt') {
              item.cImg = txtIcon
            } else if (suffix === 'pdf') {
              item.cImg = pdf
            } else {
              item.cImg = unknowFileIcon
            }
          } catch (error) {

          }
        }
        // 小程序
        if (item.contentType === 33) {
          try {
            let _content = JSON.parse(item.content)
            item.miniImg = _content.miniImg
            item.miniName = _content.miniName
            item.miniDsc = _content.miniDsc
            item.miniTitle = _content.miniTitle
          } catch (error) {

          }
        }
        // 视频号
        if (item.contentType === 51) {
          try {
            let _content = JSON.parse(item.msgMemo)
            item.miniDsc = _content.miniDsc
            item.miniImg = _content.miniImg
            item.miniTitle = _content.miniTitle
            item.bigImg = _content.bigImg
          } catch (error) {

          }
        }
        return item
      })
      this.$nextTick(() => {
        let container = this.$el.querySelector('li:last-child')
        if (!this.loadHisMsg && container !== null) {
          // 滑动到可见
          container.scrollIntoView()
        }
        if (this.loadHisMsg) {
          let container2 = this.$el.querySelector('li:nth-child(4)')
          container2 && container2.scrollIntoView()
        }
      })
    },
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time (date) {
      if (typeof date === 'string') {
        date = new Date(date)
      }
      let min = ''
      if (date.getMinutes() < 10) {
        min = '0' + date.getMinutes()
      } else {
        min = date.getMinutes()
      }
      let hour = ''
      if (date.getHours() < 10) {
        hour = '0' + date.getHours()
      } else {
        hour = date.getHours()
      }
      let second = ''
      if (date.getSeconds() < 10) {
        second = '0' + date.getSeconds()
      } else {
        second = date.getSeconds()
      }
      const curDate = new Date()
      curDate.setHours(0)
      curDate.setMinutes(0)
      curDate.setSeconds(0)
      if (date < curDate) {
        return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + '/ ' + hour + ':' + min + ':' + second
      } else {
        return hour + ':' + min + ':' + second
      }
    }
  },
}

</script>
<style lang="less" >
.clearfloat:after {
  display: contents;
  clear: both;
  content: '';
  visibility: hidden;
  height: 0;
}
.clearfloat {
  zoom: 1;
}
.m-message {
  padding: 10px 15px;
  li {
    margin-bottom: 15px;
    overflow: hidden;
  }
  .time {
    margin: 7px 0;
    text-align: center;
    > span {
      display: inline-block;
      padding: 4px 12px;
      font-size: 12px;
      color: #969799;
      //   border-radius: 2px;
      //   background-color: #dcdcdc;
    }
  }
  .avatar {
    float: left;
    width: 35px;
    height: 35px;
    margin: 0 10px 0 0;
    border-radius: 4px;
  }
  .m-message-div {
    width: 100%;
  }
  // 视频样式
  .text-video {
    width: 128px;
    height: auto;
    display: inline-block;
    position: relative;
    cursor: pointer;
    &:before {
      content: ' ';
      position: absolute;
      top: 9px;
      right: 100%;
      border: 6px solid transparent;
      border-right-color: #fff;
    }
  }
  // 图片样式
  .text-img {
    max-width: 200px;
    height: auto;
    display: inline-block;
    position: relative;
    cursor: pointer;
    &:before {
      content: ' ';
      position: absolute;
      top: 9px;
      right: 100%;
      border: 6px solid transparent;
      border-right-color: #fff;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  // 链接样式
  .text-url-img {
    display: inline-block;
    position: relative;
    background: #fff;
    width: 220px;
    max-height: 120px;
    padding: 12px;
    text-align: left;
    border-radius: 4px;
    cursor: pointer;
    &:before {
      content: ' ';
      position: absolute;
      top: 9px;
      right: 100%;
      border: 6px solid transparent;
      border-right-color: #fff;
    }
    .text-url-img-top {
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 14px;
      line-height: 22px;
    }
    .text-url-img-bottom {
      .text-url-img-content {
        width: 140px;
        float: left;
        padding-top: 6px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        font-size: 10px;
        line-height: 14px;
      }
      img {
        float: right;
        width: 40px;
        height: 40px;
        margin-top: 6px;
      }
    }
  }
  // 文件样式
  .text-file-img {
    display: inline-block;
    position: relative;
    width: 220px;
    height: 76px;
    background: #fff;
    text-align: left;
    padding: 12px 22px 12px 12px;
    cursor: pointer;
    border-radius: 4px;
    &:before {
      content: ' ';
      position: absolute;
      top: 9px;
      right: 100%;
      border: 6px solid transparent;
      border-right-color: #fff;
    }
    .text-file-img-left {
      width: 150px;
      float: left;
      .text-file-name {
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size: 14px;
        line-height: 22px;
        padding-right: 10px;
      }
      .text-file-size {
        font-size: 8px;
      }
    }
    .text-file-img-right {
      float: right;
      img {
        width: 30px;
        height: 40px;
      }
    }
  }
  // 视频号样式
  .text-video-code {
    background-color: #fffffd;
    max-width: 200px;
    height: auto;
    display: inline-block;
    position: relative;
    text-align: left;
    border-radius: 4px;
    &:before {
      content: ' ';
      position: absolute;
      top: 9px;
      right: 100%;
      border: 6px solid transparent;
      border-right-color: #fff;
    }
    .text-video-code-top {
      width: 100%;
      height: 160px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      position: relative;
    }
    .text-video-code-bottom {
      margin-top: 6px;
      .text-video-code-bottom-head {
        border-radius: 50%;
        width: 25px;
        height: 25px;
        margin-left: 16px;
        vertical-align: middle;
      }
      .text-video-code-bottom-title {
        font-size: 14px;
        line-height: 10px;
        margin-left: 5px;
        font-weight: bold;
      }
    }
    .text-video-code-bottom-content {
      margin: 8px 16px 10px 16px;
      font-size: 15px;
    }
    .text-video-code-bom {
      margin: 5px 16px;
      border-top: 1px solid silver;
      line-height: 22px;
    }
  }
  // 小程序样式
  .text-mini {
    background-color: #fffffd;
    max-width: 220px;
    height: auto;
    display: inline-block;
    position: relative;
    text-align: left;
    border-radius: 4px;
    &:before {
      content: ' ';
      position: absolute;
      top: 9px;
      right: 100%;
      border: 6px solid transparent;
      border-right-color: #fff;
    }
    .text-mini-top {
      width: 100%;
      height: 40px;
      border-radius: 4px;
      line-height: 40px;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .text-mini-top-img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        vertical-align: middle;
        margin: 5px 5px 5px 10px;
      }
      .text-mini-top-span {
        font-size: 7px;
      }
    }
    .text-mini-title {
      margin: 0px 10px;
      .text-mini-title-span {
        font-weight: bold;
        font-size: 14px;
      }
    }
    .text-mini-img {
      max-width: 200px;
      margin: 10px 10px;
    }
    .text-mini-bom {
      margin-bottom: 4px;
      margin-left: 4px;
      border-top: 1px solid silver;
      line-height: 20px;
    }
  }

  .text {
    display: inline-block;
    position: relative;
    padding: 3px 15px;
    max-width: ~'calc(100% - 80px)';
    min-height: 30px;
    line-height: 30px;
    font-size: 12px;
    text-align: left;
    word-break: break-all;
    background-color: #fff;
    border-radius: 4px;
    &:before {
      content: ' ';
      position: absolute;
      top: 9px;
      right: 100%;
      border: 6px solid transparent;
      border-right-color: #fff;
    }
  }
  .self {
    text-align: right;
    .avatar {
      float: right;
      width: 35px;
      height: 35px;
      margin: 0 0 0 10px;
      border-radius: 4px;
    }
    .text-img {
      float: right;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #fff;
      }
    }
    .text {
      background-color: #b2e281;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #b2e281;
      }
    }
    // 链接样式
    .text-url-img {
      float: right;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #fff;
      }
    }
    //文件样式
    .text-file-img {
      float: right;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #fff;
      }
    }
    // 视频号右边样式
    .text-video-code {
      float: right;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #fff;
      }
    }
    // 小程序右边样式
    .text-mini {
      float: right;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #fff;
      }
    }
  }
}
// 蒙层
.handleDialog {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  border-radius: 4px;
  text-align: center;
}
</style>
